<div class="row justify-content-between align-items-center" mat-dialog-title>
    <h5 class="col-10 mb-0 text-left">Consulta</h5>
    <div class="col-md-auto col-2">
        <i class="fas fa-times icon-close" (click)="dialogRef.close()"></i>
    </div>
</div>
<mat-dialog-content>
    <iframe [src]="url"   frameborder="0" allowfullscreen AllowTransparency></iframe>
</mat-dialog-content>       